import React from 'react';
import { Section } from '../ui/Section';
import { CheckSquare, FileText, BookOpen } from 'lucide-react';
export function Deliverables() {
  const workbookItems = ['Checklist diario (10 min)', 'Plantilla de “día por bloques”', 'Semáforo de umbrales (verde/amarillo/rojo)', 'Mapa 30/60/90 para transición', '“Plan de salida en una hoja”', 'Guiones listos (poner límites sin pelear)'];
  return <Section variant="dark" data-id="element-1">
      <h2 className="text-3xl font-bold text-white uppercase tracking-tight mb-8" data-id="element-2">
        Qué recibes exactamente
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-3">
        {/* Main PDF */}
        <div className="bg-neutral-900 p-6 rounded-xl border border-neutral-800" data-id="element-4">
          <div className="flex items-center gap-3 mb-4" data-id="element-5">
            <BookOpen className="text-red-500" data-id="element-6" />
            <h3 className="text-xl font-bold text-white" data-id="element-7">PDF Principal</h3>
          </div>
          <p className="text-neutral-400" data-id="element-8">
            El Plan de Supervivencia de 30 Días completo. Estrategia pura, sin
            relleno.
          </p>
        </div>

        {/* Workbook */}
        <div className="bg-neutral-900 p-6 rounded-xl border border-neutral-800" data-id="element-9">
          <div className="flex items-center gap-3 mb-4" data-id="element-10">
            <FileText className="text-red-500" data-id="element-11" />
            <h3 className="text-xl font-bold text-white" data-id="element-12">Workbook de Acción</h3>
          </div>
          <ul className="space-y-3" data-id="element-13">
            {workbookItems.map((item, i) => <li key={i} className="flex items-start text-neutral-300 text-sm" data-id="element-14">
                <CheckSquare className="w-4 h-4 text-neutral-500 mr-3 mt-0.5 flex-shrink-0" data-id="element-15" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>

      <p className="text-center text-neutral-500 mt-8 italic" data-id="element-16">
        Diseñado para leerse rápido y aplicarse de inmediato.
      </p>
    </Section>;
}